import React from 'react';
import s from '../../CartItem.scss';
import {CartItemDataHook} from '../../CartItem';
import {LineItemModel} from '../../../../../../domain/models/LineItems/LineItem.model';

export const Price = ({lineItem}: {lineItem: LineItemModel}) => {
  return (
    <div className={s.prices}>
      {lineItem.pricing.unitPrice.formattedConvertedAmount && (
        <span data-hook={CartItemDataHook.Price} className={s.price} data-wix-line-item-price={CartItemDataHook.Price}>
          {lineItem.pricing.breakdown.basePrice.formattedConvertedAmount}
        </span>
      )}
    </div>
  );
};
